const baseURL = 'https://promo.rentatuapp.org/';

export default baseURL;
